<span *ngIf="restaurantId">
  <div class="grid">
    <div *ngIf="component" class="k-toolbar k-grid-toolbar custom-toolbar">
      <div class="filters-section">
        <kendo-dropdownlist
          [data]="productTypes"
          [(ngModel)]="productType"
          textField="name"
          valueField="id"
        ></kendo-dropdownlist>
        
        <kendo-dropdownlist
          [data]="categories"
          [(ngModel)]="selectedCategory"
          textField="name"
          valueField="id"
          (ngModelChange)="updateParameters()"
          [defaultItem]="defaultCategory"
        ></kendo-dropdownlist>
        <app-delivery-price-message></app-delivery-price-message>
      </div>
      <div class="buttons-section">
        <button
          kendoTooltip
          kendoButton
          [title]="rbiRecommendationsDate ? 'Load RBI recommended prices as of ' + (rbiRecommendationsDate | date:'MMMM yyyy') : 'This button is disabled because there are no RBI recommendations loaded for the selected tier.'"
          size="small"
          fillMode="outline"
          (click)="showLoadRbiRecommendationsConfirmation = true"
          themeColor="primary"
          [disabled]="!rbiRecommendationsDate"
        >
          Load RBI Recommendations
        </button>
        
        <kendo-badge-container>
          <button
            kendoButton
            size="small"
            fillMode="outline"
            [disabled]="component.cache.size == 0"
            (click)="saveChanges()"
            themeColor="primary"
          >
            Save
          </button>
          <kendo-badge
            *ngIf="component.cache.size > 0"
            size="small"
            rounded="full"
            [align]="{ vertical: 'top', horizontal: 'end' }"
            themeColor="success"
            >{{ component.cache.size }}</kendo-badge
          >
        </kendo-badge-container>

        <app-grid-manager-toolbar
          [showConfig]="true"
          [showImport]="locked ? [] : ['Current Type', 'All']"
          (exportToExcel)="exportToExcel($event)"
          (uploadSuccessful)="updatePendingChanges()"
          [fontSize]="component.fontSize"
          (fontSizeChange)="updateFontSize($event)"
          [columns]="component.columns"
          [importUrl]="component.importUrls"
          view="pricing"
          ><ng-template #configurationTemplate
            ><app-configuration></app-configuration></ng-template
        ></app-grid-manager-toolbar>
      </div>
    </div>
    <router-outlet (activate)="onActivate($event)"></router-outlet>
  </div>
</span>


<kendo-dialog
  [width]="700"
  *ngIf="showLoadRbiRecommendationsConfirmation"
  (close)="showLoadRbiRecommendationsConfirmation = false"
>
  <kendo-dialog-titlebar> Load RBI Recommendations </kendo-dialog-titlebar>

  <p>Are you sure you want to load RBI recommended prices as of <strong>{{rbiRecommendationsDate | date:'MMMM yyyy'}}</strong>?</p>

  <p>Prices will be saved for you to sync when ready.</p>

  <kendo-dialog-actions layout="end">
    <button kendoButton (click)="showLoadRbiRecommendationsConfirmation = false">Cancel</button>
    <button
      kendoButton
      (click)="loadRbiRecommendations()"
      themeColor="primary"
    >
      Load
    </button>
  </kendo-dialog-actions>
</kendo-dialog>
